export const environment = {
  production: false,
  'iam.basePath': '/.kratos/public',
  'minio.basePath': 'https://minio.development.romeo.fullstackagency.it/inbox/',
};
